export default __webpack_public_path__ + "87e30c3aae10c52b4e26a02123c63c77.svg";